"use strict";
class ExternalTriggerInterfaceClass {
    constructor() {
        this._addToCartResponse = (res) => { };
        this._addToCartFinally = () => { };
        this._updateCartQuantity = (parsedState) => { };
    }
    wrapOnSubmitFinallyHandler(fn) {
        const productFormExternal = document.querySelectorAll('product-form-external');
        productFormExternal.forEach((el) => {
            const handlerCopy = el.onSubmitFinallyHandler;
            const wrapperFn = () => {
                handlerCopy.apply(el);
                fn(el);
            };
            el.onSubmitFinallyHandler = wrapperFn;
        });
    }
    wrapOnResponseHandler(fn) {
        const productFormExternal = document.querySelectorAll('product-form-external');
        productFormExternal.forEach((el) => {
            const handlerCopy = el.responseHandler;
            const wrapperFn = (response) => {
                handlerCopy.apply(el, [response]);
                fn(response);
            };
            el.responseHandler = wrapperFn;
        });
    }
    get addToCartResponse() {
        return this._addToCartResponse;
    }
    get addToCartFinally() {
        return this._addToCartFinally;
    }
    get updateCartQuantity() {
        return this._updateCartQuantity;
    }
    set addToCartResponse(fn) {
        this._addToCartResponse = fn;
        this.wrapOnResponseHandler(fn);
    }
    set addToCartFinally(fn) {
        this._addToCartFinally = fn;
        this.wrapOnSubmitFinallyHandler(fn);
    }
    set updateCartQuantity(fn) {
        this._updateCartQuantity = fn;
    }
}
const externalTriggerInterface = new ExternalTriggerInterfaceClass();
